import React, { Component } from "react";
import "../css/completeItem.css";
import { FaFacebook, FaTwitter, FaEnvelope, FaLinkedin, FaPinterest } from 'react-icons/fa';
import PlanPage from "./PlanPage";

import ReactGA from 'react-ga';

import { css } from 'emotion';
import { ShareButtonIconOnly, ShareBlockStandard } from 'react-custom-share';

class CompleteItem extends Component {

    constructor(props) {
        super(props)
        this.state = {
            hidden: false,
            openPlanPage: false
        }
    }

    render() {




        var item = this.props.item;
        const planId = item.planId;
        const bedrooms = item.bedrooms;
        const bathrooms = item.bathrooms;
        const total_sqft = item.total_sqft;
        const levels = item.levels;
        const image = item.main_image;
        const packageName = item.packageName;
        const packagePrice = item.packagePrice;
        const foundation = item.foundation;


        var shortDescription = "I just bought this " + this.randomDescriptionWord() + " " + bedrooms + " bed, " + bathrooms + " bath house plan from houseplanstore.com";

        const shareBlockProps = {
            url: 'https://www.houseplanstore.com/plans/types/houseplans/plan/' + planId,
            button: ShareButtonIconOnly,
            buttons: [
                { network: "Twitter", icon: FaTwitter },
                { network: "Facebook", icon: FaFacebook },
                { network: "Email", icon: FaEnvelope },
                {
                    network: "Pinterest",
                    icon: FaPinterest,
                    media: "https://www.houseplanstore.com/media/" + image
                },
                { network: "Linkedin", icon: FaLinkedin }
            ],
            text: shortDescription,
        };

        var hidden = {};
        if (this.state.hidden == true) {
            hidden = { height: "0px", marginTop: "0px", opacity: 0 };
        }

        return (
            <div>
                {this.renderPlanPage()}

                <div style={hidden} className="complete_favoriteHolder">

                    <div onClick={() => { this.setState({ openPlanPage: true }) }} className="complete_row1">
                        <img className="complete_mainImage" src={"https://www.houseplanstore.com/media/" + image} />
                        <div className="complete_planInfo">
                            <span className="complete_favoritePlanId">{planId}</span><br />
                            <span className="complete_text">Levels: <strong>{levels}</strong></span><br />
                            <span className="complete_text">Bedrooms: <strong>{bedrooms}</strong></span><br />
                            <span className="complete_text">Bathrooms: <strong>{bathrooms}</strong></span><br />
                            <span className="complete_text">Sqft: <strong>{total_sqft}</strong></span>
                        </div>
                    </div>

                    <div className="complete_row2">
                        <div className="complete_itemRow">
                            <div style={{ flex: 5 }}>{packageName}</div>
                            <div style={{ flex: 1, textAlign: "right" }}>${packagePrice}</div>
                        </div>
                        <div className="complete_itemRow">
                            <div style={{ flex: 3 }}>Foundation</div>
                            <div style={{ flex: 2, textAlign: "right" }}>{foundation}</div>
                        </div>
                        {this.renderExtras()}

                    </div>

                    <div onClick={() => { this.faceBookShareClicked() }} style={{ width: 100 + "%" }}>
                        <ShareBlockStandard {...shareBlockProps} />
                    </div>

                </div>
            </div>
        );
    }

    randomDescriptionWord = () => {
        var words = [
            'beautiful',
            'wonderful',
            'charming',
            'stunning',
            'gorgeous'
        ];
        var randomIndex = Math.floor(Math.random() * 10) % words.length;
        return words[randomIndex];
    }

    faceBookShareClicked = () => {
        ReactGA.event({
            category: 'User',
            action: 'Facebook Share Clicked After Checkout',
            label: this.state.planId
        });
    }

    renderExtras = () => {
        //if (!!this.props.item.extras) {
        var array = [];
        for (var i = 0; i < Object.keys(this.props.item.extras).length; i++) {
            array.push(
                <div key={i} className="complete_itemRow">
                    <div style={{ flex: 5 }}>{this.props.item.extras[i][0]}</div>
                    <div style={{ flex: 1, textAlign: "right" }}>${this.props.item.extras[i][1]}</div>
                </div>
            );
        }
        return array;

    }

    updateFunction = () => {
        this.setState({ openPlanPage: !this.state.openPlanPage });
    }


    renderPlanPage = () => {
        if (this.state.openPlanPage == true) {
            return (
                <PlanPage updateFunction={this.updateFunction} planId={this.props.item.planId} />
            );
        }
    }


}

export default CompleteItem;